(function (angular, app) {
   "use strict";

    angular.module(app.modules.common.name)
        .constant(app.modules.common.constants.genderenum,
        
        {
            Male: 'Male',
            Female: 'Female' 
        }
        
        );
}(angular, app));
